import axios, {AxiosInstance, AxiosResponse} from 'axios'
import { cookies } from 'brownies';
import User from "@/logic/model/User";
import UserMarshaller from "@/logic/model/UserMarshaller";

export default class ApiConnector {

    private baseURL:string = 'https://api.dhaering.de';
    private http:AxiosInstance = axios.create();

    constructor() {
        if (process.env.NODE_ENV === 'development') {
            this.baseURL = 'http://localhost:8000';
        }

        if(cookies.token) {
            this.createAxiosInstance(cookies.token)
        } else {
            this.createAxiosInstance()
        }
    }

    private createAxiosInstance(token:string|undefined = undefined) {
        let config:any = {
            baseURL: this.baseURL,
            timeout:10000,
        };

        if(token) {
            config['headers'] = {
                Authorization: `Bearer ${cookies.token}`
            };
        }
        this.http = axios.create(config)
    }

    public get(path:string) {
        if (this.isTokenExpired()) {
            throw Error("Token Expired")
        }
        return this.http.get(this.baseURL + path).then(response => {
            return response.data
        })

    }

    public post(path:string,body:Object) {
        if (this.isTokenExpired()) {
            throw Error("Token Expired")
        }
        return this.http.post(this.baseURL + path,body)
    }

    public patch(path:string,body:Object) {
        if (this.isTokenExpired()) {
            throw Error("Token Expired")
        }
        return this.http.patch(this.baseURL + path,body)
    }

    public delete(path:string) {
        if (this.isTokenExpired()) {
            throw Error("Token Expired")
        }
        return this.http.delete(this.baseURL + path)
    }

    public getTokenExpireDate(token:string) {
        let json : any = atob(token.split(".")[1]);
        let payload = JSON.parse(json);
        let expireDate = payload["exp"];

        let date = new Date(expireDate * 1000);
        return date

    }

    public isTokenExpired() {
        if (cookies.token) {
            let expireDate = this.getTokenExpireDate(cookies.token);
            return (Date.now() - expireDate.getTime()) > 0;
        }
        return true;
    }

    public hasToken() {
        return cookies.token !== "" && cookies.token !== undefined
    }

    public login(email:string,password:string) {
        return this.http.post('/api/login',{
            email,
            password
        }).then(response => {
            cookies.token = response.data.token;
            this.createAxiosInstance(response.data.token);
            let userResponse = response.data.user;
            let user = new User(userResponse.name,userResponse.id,Boolean(userResponse.is_admin),Boolean(userResponse.send_mails))
            cookies.user = userResponse;
            return user
        })
    }

    public logout() {
        cookies.token = undefined;
        cookies.user = undefined;
    }

    public getUser() {
        if (cookies.user) {
            return new UserMarshaller(cookies.user).toModel()
        }
        return new User("Gast")
    }


}